export default __webpack_public_path__ + "50dbd712eaeef0470b506d6659cf1cb9.svg";